/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Rounds_Prelim_HintInputs */



/**
* | output |
* | --- |
* | "Preliminary rounds only — the final is not included." |
*
* @param {Tfield_Rounds_Prelim_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_rounds_prelim_hint = /** @type {((inputs?: Tfield_Rounds_Prelim_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Rounds_Prelim_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes préliminaires uniquement — la finale n'est pas incluse.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo rondas preliminares — la final no está incluida.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas rodadas preliminares — a final não está incluída.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo round preliminari — la finale non è inclusa.")
	return /** @type {LocalizedString} */ ("Preliminary rounds only — the final is not included.")
});